import { render } from "./EmployeePersonalDetails.vue?vue&type=template&id=6dc896a6&scoped=true"
import script from "./EmployeePersonalDetails.vue?vue&type=script&lang=js"
export * from "./EmployeePersonalDetails.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=6dc896a6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc896a6"]])

export default __exports__